import Locale from './Locale';
import withHandlers from 'recompose/withHandlers';

import { trackBookLanguageChange } from '../../../../../analytics/category/product';

const enhance = withHandlers({
  onHandleChange: props => event => {
    trackBookLanguageChange();
    props.onHandleChange(event);
  }
});

export default enhance(Locale);
